import React, { PureComponent } from 'react';
import RenewalsDashboard from '../../containers/renewals/Dashboard/Dashboard';
import MRSDashboard from '../../containers/MRS/Dashboard';
import PageBase from '../../widgets/PageBase/PageBase';
import { injectIntl } from 'react-intl';

class Dashboard extends PureComponent {
  render() {
    return (
      <PageBase
        navigation={[
          this.props.intl.formatMessage({
            id: 'drawer.dashboard'
          })
        ]}
        noWrapContent
      >
        <div className="row">
          <div className="col-md-6">
            <RenewalsDashboard />
          </div>
          <div className="col-md-6">
            <MRSDashboard />
          </div>
        </div>
      </PageBase>
    );
  }
}

export default injectIntl(Dashboard);
